"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCreativeData = void 0;
const parseCreativeData = (creativeDataObj) => {
    return Object.values(creativeDataObj).reduce((acc, de) => {
        if (de.displayName) {
            acc[de.displayName] = de.value;
        }
        return acc;
    }, {});
};
exports.parseCreativeData = parseCreativeData;
//# sourceMappingURL=creatives.js.map